/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// This file is only necessary while we have the hybrid page.  Afterwards we can point to the pageview template and
// controller directly from unit.js

angular.module('bulbApp.unitModule')
.controller('PageController', ['unit', 'CONFIG', PageController]);

function PageController(unit, CONFIG) {
  this.unit = unit;
  // context.name is a server-set property. It may not exist in development mode.
  // this.serverContext doesn't seem to be used anywhere, so it may be safe to remove it.
  this.serverContext = CONFIG.context?.name;
}


